<template>
  <div class="main-chapter">
    <transition name="fade">
      <div
        v-if="!permission"
        style="position:absolute; width: 100%; height:100%; top:0; left:0; z-index:10000; background-color:white; transtition: 1s;"
      >
        <div
          style="margin-left: auto; margin-right: auto; height:100%; width:100%; display: flex;align-items: center;"
        >
          <img
            src="https://uploads-ssl.webflow.com/63377a4edcea6933891249a2/63377d0fd67f06ef48eef306_MORIEL%20ENGLISH%20LOGO.svg"
            style="animation: wiggle 1.5s infinite; width: 80%; margin: auto"
          />
        </div>
      </div>
    </transition>
    <div v-if="course" :style="safeZones" class="chapter-course" id="chapter-course">
      <div
        v-for="(section, idx) in course.section"
        class="chapter-section"
        :key="idx"
      >
        <h5 class="sectionTitle">{{ section.name }}</h5>
        <div
          class="chapter-part"
          v-for="(lesson, idx) in section.lesson"
          :key="idx"
          @click="goTo(lesson, id, course.name)"
        >
          <div v-bind:id="`lesson_${lesson.id}`" class="container-course">
            <div
              class="step shrink-on-active"
              :class="{
                completed: progress.includes(lesson.id),
                active: nextLesson.id === lesson.id
              }"
            >
              <div class="v-stepper-course">
                <div class="circle">
                  <!-- in case its only check but no V-check... -->
                  <!-- <div
                    v-if="nextLesson.id === lesson.id"
                    class="inner-circle"
                  ></div> -->

                  <inline-svg
                    v-if="progress.includes(lesson.id)"
                    class="check-v"
                    :src="require('../../assets/svg/GreenCheck.svg').default"
                  ></inline-svg>
                </div>
                <inline-svg
                  v-if="
                    lesson.game &&
                      lesson.game.permission !== 'unknown' &&
                      lesson.game.permission !== permission &&
                      permission !== 'paying' &&
                      lesson.game.permission == 'registered'
                  "
                  width="14px"
                  class="lockSign"
                  :src="require('../../assets/svg/googleicon.svg').default"
                />
                <inline-svg
                  v-if="
                    !lesson.game &&
                      lesson.permission !== 'unknown' &&
                      lesson.permission !== permission &&
                      permission !== 'paying' &&
                      lesson.permission == 'registered'
                  "
                  width="14px"
                  class="lockSign"
                  :src="require('../../assets/svg/googleicon.svg').default"
                />
                <div v-if="section.lesson.length != idx + 1" class="line"></div>
              </div>
              <div
                class="content"
                :class="{
                  disabled:
                    lesson &&
                    lesson.permission !== 'unknown' &&
                    lesson.permission !== permission &&
                    permission !== 'paying',
                  disabled2:
                    lesson.game &&
                    lesson.game.permission !== 'unknown' &&
                    lesson.game.permission !== permission &&
                    permission !== 'paying'
                }"
              >
                {{ lesson.name }}
              </div>
              <inline-svg
                  v-if="
                    lesson.game &&
                      lesson.game.permission !== 'unknown' &&
                      lesson.game.permission !== permission &&
                      permission !== 'paying' &&
                      lesson.game.permission == 'paying'
                  "
                  width="14px"
                  class="lockSign"
                  @click="goPay"
                  :src="require('../../assets/svg/lock.svg').default"
                />
                <inline-svg
                  v-if="
                    !lesson.game &&
                      lesson.permission !== 'unknown' &&
                      lesson.permission !== permission &&
                      permission !== 'paying' &&
                      lesson.permission == 'paying'
                  "
                  width="14px"
                  class="lockSign"
                  @click="goPay"
                  :src="require('../../assets/svg/lock.svg').default"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="spacer"></div> -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="true"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="true"
    >
      {{ text }}
      <div class="snackBtns">
        <v-btn v-if="snacktype == 'reg'" color="white" flat @click="login">
          {{ $t("chapter.chapter-course.login") }}
        </v-btn>
        <v-btn v-if="snacktype == 'paid'" color="white" @click="goPay">
          {{ $t("chapter.chapter-course.pay") }}
        </v-btn>
        <v-btn color="red" flat @click="snackbar = false">
          {{ $t("chapter.chapter-course.exit") }}
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { userService } from "../../services/userService";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import "./chapter-course.scss";
import SlinkyVue from "../Shared/Slinky.vue";
// import ProgressBar from "../Shared/progressBar.vue";
export default {
  name: "chapter-course",
  props: ["course", "id", "progress", "nextLesson", "permission"],
  data() {
    return {
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 3500,
      text: this.$t("chapter.chapter-course.error"),
      snacktype: null,
      platform: null
    };
  },
  created() {
    // console.log("COURSE", this.course);
    // console.log(this.nextLesson);
    this.platform = Capacitor.getPlatform();
  },
  computed: {
    safeZones() {
      return {
        "--safe":
          this.$store.getters.safeBottom + this.$store.getters.safeTop + "px"
      };
    }
  },
  watch: {
    nextLesson() {
      this.scrollToNext();
    }
    // course() {
    //   setTimeout(() => {

    //   }, 450);
    // }
  },
  mounted() {
    this.scrollToNext();
  },
  methods: {
    goPay() {
      this.$router.push({
        path: `/registration`
      });
    },
    scrollToNext() {
      if (this.nextLesson.id) {
        this.$nextTick(function() {
          document
            .getElementById(`lesson_${this.nextLesson.id}`)
            .firstChild.classList.add("nextLesson");

          const topPosition = document.querySelector(".nextLesson");
          if (topPosition)
            document.querySelector("#chapter-course").scrollBy({
              top: topPosition.getBoundingClientRect().top - 280,
              behavior: "smooth"
            });
        });
      }
    },
    // login() {
    //   this.snackbar = false;
    //   this.$router.push({
    //     path: `/login`
    //   });
    // },
    async login() {
      if (this.platform == "web") {
        // const b = await userService.googleLogin();
      } else {
        const response = await GoogleAuth.signIn();
        console.log(response);
        // const token = await userService.getToken(
        //   response.authentication.accessToken
        // );
      }
      this.snackbar = false;
      // console.log(b);
    },
    goTo: function(lesson, courseId, courseName) {
      if (
        lesson.game &&
        lesson.game.permission === "paying" &&
        this.permission !== "paying"
      ) {
        // this.text = "רק למשתמשים משלמים";
        // this.snacktype = "paid";
        // this.snackbar = true;
        // console.log("reg only");
        this.goPay();
        return;
      }
      if (
        !lesson.game &&
        lesson.permission === "paying" &&
        this.permission !== "paying"
      ) {
        // this.text = "רק למשתמשים משלמים";
        // this.snacktype = "paid";
        // this.snackbar = true;
        // console.log("reg only");
        this.goPay();
        return;
      }
      if (
        lesson.game &&
        lesson.game.permission !== "unknown" &&
        lesson.game.permission !== this.permission &&
        this.permission !== "paying"
      ) {
        this.text = this.$t("chapter.chapter-course.only-signup");
        this.snacktype = "reg";
        this.snackbar = true;
        console.log("reg only");
        return;
      }
      if (
        !lesson.game &&
        lesson.permission !== "unknown" &&
        lesson.permission !== this.permission &&
        this.permission !== "paying"
      ) {
        this.text = this.$t("chapter.chapter-course.only-signup");
        this.snacktype = "reg";
        this.snackbar = true;
        console.log("reg only");
        return;
      }

      // if (
      //   lesson.id != this.nextLesson.id &&
      //   !this.progress.includes(lesson.id)
      // ) {
      //   this.text = "צריך לסיים את השלבים הקודמים כדי להגיע לכאן";
      //   this.snacktype = "premature";
      //   this.snackbar = true;
      //   console.log("premature");
      //   return;
      // }
      this.$store.commit({
        type: "setCurrentGame",
        lesson,
        courseId,
        courseName
      });

      this.$router.push({
        path: `/lesson/${lesson.id}`
      });
    }
  },
  components: {
    // ProgressBar
    SlinkyVue
  }
};
</script>

<style scoped>
.disabled,
.disabled2 {
  opacity: 0.5;
}
button {
  border: none;
  margin-top: 16px !important;
}
.v-btn__content {
  margin-top: 10px;
}
.v-snack--vertical .v-snack__content {
  padding: 14px 24px;
}
.spacer {
  height: 250px;
  min-height: 250px;
  width: 100%;
  background: transparent;
}
.snackBtns {
  display: flex;
  justify-content: space-around;
}
.sectionTitle {
  font: var(--medium-font);
}
.chapter-course {
  height: calc(100vh - 155px - var(--safe));
}
.loader {
  margin: 30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// chapter-course.vue?9503a8b6